import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage, faList } from "@fortawesome/free-solid-svg-icons";
import "../src/assets/components/global.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./authprovider"; // Import the useAuth hook
import AutoLogout from "./autologout";
import axios from "axios";
import logo from "../src/assets/components/images/Lanao_del_Norte_Seal.png";

function Officerpage() {
  const navigate = useNavigate();
  const [newmeeting, setNewmeeting] = useState("0");
  const [isHamburgerClicked, setIsHamburgerClicked] = useState(false);

  const { logout } = useAuth(); // Destructure the logout function from useAuth

  const handleHamburgerClick = () => {
    setIsHamburgerClicked(!isHamburgerClicked);
  };

  useEffect(() => {
    axios
      .get("https://brgytracerappserver.onrender.com/officerpage")
      .then((response) => {
        setNewmeeting(response.data.newmeeting);
        // setLoading(false);
      })
      .catch((error) => {
        // setError(error);
        // setLoading(false);
      });
  }, []);

  const visitorReg = () => {
    navigate("/visitorregistry");
  };
  const listuser = () => {
    navigate("/listuser");
  };

  const handleLogout = () => {
    logout(); // Call the logout function from useAuth to clear user data
  };
  const listvisitors = () => {
    navigate("/listvisitor");
  };
  const viewnewmeeting = () => {
    navigate("/officerviewmeeting");
  };
  const addcases = () => {
    navigate("/addcase");
  };
  const viewcase = () => {
    navigate("/viewcases");
  };
  const meeting = () => {
    navigate("/officersetmeeting");
  };

  return (
    <div className="officerpage-parent parent-height">
      <AutoLogout />
      <div className="admin-holder">
        <div
          id="hamburger"
          className={`header-area ${isHamburgerClicked ? "is-clicked" : ""}`}
          onClick={handleHamburgerClick}>
          <div className="hidden-menuBar">
            <div className="navigation"></div>
            <ul>
              <img src={logo} alt="" title="" width="100px" height="100px" />
              <li onClick={meeting}>setMeeting</li>
              <li onClick={listuser}>Members</li>
              <li onClick={visitorReg}>VisitorRegistry</li>
              <li onClick={listvisitors}>Visitor</li>
              <li>Chat</li>
              <li onClick={handleLogout}>Logout</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="meeting-and-newuser-container">
        <div className="all-meeting-parent">
          <div>
            <li onClick={viewnewmeeting}>View</li>
            <FontAwesomeIcon icon={faMessage} />
            <h5>{newmeeting}</h5>
          </div>
        </div>
        <div className="all-cases-parent">
          <div>
            <li onClick={addcases}>Addcase</li>
            <FontAwesomeIcon icon={faList} />
          </div>
        </div>
        <div className="view-cases-parent">
          <div>
            <li onClick={viewcase}>View</li>
            <FontAwesomeIcon icon={faList} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Officerpage;
